'use client';

import {motion} from 'motion/react';

export const Logo = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={153}
			height={44}
			fill="none"
			viewBox="0 0 153 44"
		>
			<g>
				<motion.path
					fill="#695BD3"
					d="m11.57 9.941 2.245-4.596c.906-1.852.12-4.076-1.755-4.974-1.875-.893-4.13-.118-5.033 1.734 0 0-5.315 10.79-5.68 11.474a13.701 13.701 0 0 0-.814 1.813A8.74 8.74 0 0 0 0 18.407c0 1.28.277 2.495.773 3.592.117.257.242.508.38.749l4.435 8.706c.935 1.837 3.202 2.578 5.06 1.653 1.86-.925 2.61-3.163 1.673-5l-.644-1.269-2.992-5.875a5.464 5.464 0 0 1-.634-2.586c0-.743.15-1.455.42-2.101l3.097-6.338v.003h.002Z"
					initial={{
						x: -1,
						opacity: 0,
					}}
					animate={{
						x: 0,
						opacity: 1,
					}}
					transition={{
						duration: 0.3,
						ease: 'easeIn',
					}}
				/>
				<motion.path
					fill="#9B90F0"
					d="M30.322 21.993a9.417 9.417 0 0 0-.38-.75l-4.436-8.705c-.935-1.837-3.202-2.578-5.06-1.653-1.861.925-2.61 3.163-1.673 5l.648 1.269 2.992 5.875c.41.771.634 1.653.634 2.586 0 .743-.15 1.455-.42 2.101l-3.097 6.338-2.245 4.597c-.905 1.852-.119 4.076 1.756 4.974 1.874.893 4.13.118 5.033-1.734 0 0 5.58-11.148 5.812-11.672.232-.524.471-1.048.681-1.615a8.74 8.74 0 0 0 .533-3.015 8.7 8.7 0 0 0-.773-3.592v-.004h-.006Z"
					initial={{
						x: -10,
						opacity: 0,
					}}
					animate={{
						x: 0,
						opacity: 1,
					}}
					transition={{
						duration: 0.3,
						ease: 'easeIn',
						delay: 0.1,
					}}
				/>
				<motion.path
					fill="#21154A"
					d="m40.542 30.205.474-.826c.222-.397.475-.58.824-.58.189 0 .38.062.632.183 1.265.64 2.594 1.008 3.892 1.008 2.277 0 3.922-1.162 3.922-3.086 0-2.046-1.898-2.81-4.017-3.636-2.593-1.039-5.536-2.2-5.536-6.05 0-3.575 2.563-6.019 7.15-6.019 2.025 0 3.575.46 4.587.885.666.275.824.826.508 1.467l-.41.856c-.223.398-.475.61-.855.61-.158 0-.38-.06-.602-.153-.885-.397-2.024-.764-3.226-.764-2.34 0-3.384 1.405-3.384 2.842 0 1.985 1.898 2.78 4.017 3.636 2.626 1.07 5.536 2.231 5.536 5.988 0 3.757-2.627 6.325-7.686 6.325-2.278 0-4.08-.58-5.378-1.224-.633-.305-.79-.825-.444-1.466l-.004.004ZM68.935 25.806h-9.331c.158 3.024 2.119 4.337 4.396 4.337 1.076 0 1.867-.151 2.594-.397.221-.061.41-.123.601-.123.411 0 .727.213.982.61l.38.58c.38.61.221 1.1-.444 1.344a12.29 12.29 0 0 1-4.113.734c-4.174 0-7.94-2.444-7.94-7.853 0-4.583 2.72-7.73 7.053-7.73 4.555 0 6.801 3.514 6.928 7.425.031.703-.38 1.07-1.106 1.07v.003Zm-5.884-5.744c-1.772 0-3.29 1.344-3.416 3.36h6.864c-.127-2.016-1.675-3.36-3.447-3.36ZM72.914 31.67V12.423c0-.703.38-1.07 1.107-1.07h1.328c.727 0 1.107.367 1.107 1.07V31.67c0 .703-.38 1.07-1.107 1.07h-1.328c-.727 0-1.107-.367-1.107-1.07ZM83.108 31.451l-4.924-12.98c-.252-.672 0-1.008.727-1.008h1.423c.727 0 1.201.336 1.456 1.008l3.419 9.524a.4.4 0 0 0 .751 0l3.421-9.524c.253-.672.76-1.008 1.487-1.008h1.392c.727 0 .98.336.727 1.008l-4.932 13a1.964 1.964 0 0 1-1.836 1.267h-1.244c-.83 0-1.575-.513-1.869-1.287h.002ZM97.162 32.74h-1.329c-.727 0-1.106-.367-1.106-1.07V12.423c0-.703.38-1.07 1.106-1.07h1.33c.726 0 1.106.367 1.106 1.07V22.45a.41.41 0 0 0 .725.264l3.735-4.425a2.281 2.281 0 0 1 1.803-.825h2.055c.727 0 .885.274.411.825l-5.008 5.923a.41.41 0 0 0-.015.51l5.372 7.162c.443.58.285.857-.443.857h-1.867c-.727 0-1.329-.275-1.772-.857l-4.259-5.675a.41.41 0 0 0-.74.246v5.214c0 .703-.38 1.07-1.106 1.07h.002ZM109.71 31.67V12.423c0-.703.38-1.07 1.107-1.07h1.329c.726 0 1.106.367 1.106 1.07V31.67c0 .703-.38 1.07-1.106 1.07h-1.329c-.727 0-1.107-.367-1.107-1.07ZM126.21 31.733l-.253-.825c-.76 1.22-2.404 1.985-4.46 1.985-2.751 0-5.378-1.314-5.378-4.583 0-4.735 5.442-5.163 8.604-5.163h1.107v-.58c0-1.71-1.423-2.505-2.974-2.505-1.359 0-2.529.244-3.669.885a1.3 1.3 0 0 1-.696.213c-.317 0-.538-.182-.76-.52l-.349-.58c-.38-.641-.253-1.162.38-1.498 1.517-.825 3.384-1.252 5.092-1.252 3.321 0 6.516 1.619 6.516 5.317v9.043c0 .702-.38 1.07-1.107 1.07h-.602c-.726 0-1.234-.337-1.456-1.009l.005.002Zm-.38-6.078h-1.107c-1.645 0-5.062.366-5.062 2.657 0 1.252 1.013 1.833 2.31 1.833 2.214 0 3.859-1.74 3.859-4.49ZM135.255 32.74h-1.329c-.727 0-1.107-.366-1.107-1.07V18.536c0-.703.38-1.07 1.107-1.07h.538c.727 0 1.234.337 1.456 1.008l.443 1.283c1.138-1.68 2.089-2.29 4.114-2.413.726-.062 1.106.305 1.106 1.038v.61c0 .673-.347 1.04-1.106 1.162-3.417.52-4.114 3.575-4.114 7.058v4.46c0 .703-.379 1.07-1.106 1.07h-.002ZM150.648 20.215h-2.089v7.576c0 1.528.286 2.352 1.456 2.352.222 0 .475-.03.791-.123.76-.184 1.17 0 1.392.641l.189.58c.222.703-.031 1.192-.696 1.375a6.973 6.973 0 0 1-1.992.274c-3.384 0-4.682-1.803-4.682-5.101v-7.576h-.443c-.727 0-1.107-.367-1.107-1.07v-.61c0-.703.38-1.07 1.107-1.07h.443l.791-3.544c.158-.702.602-1.038 1.328-1.038h.317c.727 0 1.106.367 1.106 1.07v3.513h2.089c.727 0 1.107.366 1.107 1.07v.61c0 .702-.38 1.069-1.107 1.069v.002Z"
					initial={{
						x: -10,
						opacity: 0,
					}}
					animate={{
						x: 0,
						opacity: 1,
					}}
					transition={{
						duration: 0.3,
						ease: 'easeIn',
						delay: 0.2,
					}}
				/>
			</g>
		</svg>
	);
};
